import { render, staticRenderFns } from "./viewGiftArticles.vue?vue&type=template&id=04de699c&scoped=true&"
import script from "./viewGiftArticles.vue?vue&type=script&lang=js&"
export * from "./viewGiftArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04de699c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04de699c')) {
      api.createRecord('04de699c', component.options)
    } else {
      api.reload('04de699c', component.options)
    }
    module.hot.accept("./viewGiftArticles.vue?vue&type=template&id=04de699c&scoped=true&", function () {
      api.rerender('04de699c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/pack/components/viewGiftArticles.vue"
export default component.exports